import axios from "axios";
import configuration from "@/utils/configuration";

export const orderService = {
  getUserOrderList(params) {
    return axios.get(`${configuration.orderUrl}/user`,{
      withCredentials: true,
      params:params
    });
  },
  getChildOrderList(params) {
    return axios.get(`${configuration.orderUrl}/parent`, {
      withCredentials: true,
      params:params,
    });
  },
  cancelOrder(orderId) {
    return axios.patch(`${configuration.orderUrl}/cancel`, null, {
      withCredentials: true,
      params: { order_id: orderId },
    });
  },
  Payment(orderId) {
    return axios.post(`${configuration.orderUrl}/payment/checkout`,null, {
      withCredentials: true,
      params: { order_id: orderId },
    });
  },
};
